import { RankRing } from './RankRing'
import { EvolvingTrophy } from './EvolvingTrophy'
import type { Category, EvolutionTier } from '@/milestones/types'

interface Props {
  category: Category
  tier: EvolutionTier
  size: number
  
  static_?: boolean
}

export function RankMedallion({ category, tier, size, static_ = false }: Props) {
  return (
    <div className="relative" style={{ width: size, height: size }}>
      <RankRing size={size} tier={tier} />
      <div className="absolute inset-[15%]">
        <EvolvingTrophy
          category={category}
          tier={tier}
          size={Math.round(size * 0.7)}
          static_={static_}
        />
      </div>
    </div>
  )
}
